export default "__VITE_ASSET__fzsQhjgD__"